<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <Form :data="entry" @save="save" />
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import restrictions, {
  Frequency,
  frequencyTitles
} from "../../services/restrictions";
import Form from "./Form.vue";

export default {
  data() {
    return {
      title: "Editar restrição",
      id: null,
      entry: {},
      isLoading: false,
      actions: [
        {
          label: "Voltar",
          route: "/configuracoes"
        }
      ],
      frequency: Object.keys(Frequency).map(key => ({
        value: key,
        title: frequencyTitles[key]
      }))
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.loadData();
  },
  methods: {
    loadData() {
      restrictions.get(this.id).then(data => {
        this.entry = data;
      });
    },
    async save(rawData) {
      try {
        await restrictions.update(this.id, rawData);

        this.$router.push({
          name: "settings"
        });
      } catch (err) {
        console.error(err);

        this.$buefy.toast.open({
          message: 'Erro ao salvar o grupos de restrições',
          type: 'is-danger',
        });
      }
    }
  },
  components: {
    ZHeader,
    Form
  }
};
</script>

<style lang="scss"></style>
